import { MODAL_AUTH } from '@components/App/Modal/constants'
import { openModal } from '@storeOld/reducers/ui'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useAuth } from '@/hooks'
import { selectIsLoading } from '@/store'
import { AuthenticatedMain } from './AuthenticatedMain'

export const Signup = () => {
  const dispatch = useDispatch()
  const { authenticated } = useAuth()
  const loading = useSelector(selectIsLoading('authentication'))

  useEffect(() => {
    if (loading || authenticated) {
      return
    }

    dispatch(openModal(MODAL_AUTH))
  }, [loading, authenticated])

  return <AuthenticatedMain />
}
